<main class="erp-home-main">
  <div class="erp-home-shell">
    <!-- Panel izquierdo -->
    <section class="erp-hero-panel">
      <div class="erp-brand-block">
        <div class="erp-logo-frame">
          <img
            src="assets/img/Zivo_only_logo.png"
            alt="ZIVO ERP"
            class="erp-logo"
          />
        </div>

        <div>
          <span class="erp-kicker">Sistema empresarial</span>
          <h1>ZIVO ERP</h1>
          <p class="erp-subtitle">Plataforma integral de gestión empresarial</p>
        </div>
      </div>

      <div class="erp-welcome-card">
        <span>Área responsable</span>
        <strong>Departamento de Innovación y Tecnología</strong>
        <small>ITE</small>
      </div>

      <section class="erp-news-panel">
        <div class="erp-section-header">
          <div>
            <h3>Novedades para usuarios</h3>
          </div>
        </div>

        <ul class="erp-news-list">
          <li>Flujo de solicitud de eventos</li>
          <li>Mejoras de experiencia de usuario</li>
          <li>Integración de biómetrico</li>
          <li>Tickets departamentales</li>
          <li>Actualización de seguridad backend</li>
        </ul>
      </section>

      <section class="erp-system-info">
        <div class="erp-info-item">
          <span>Versión</span>
          <strong>1.3.0</strong>
        </div>

        <div class="erp-info-item">
          <span>Ambiente</span>
          <strong>Producción</strong>
        </div>

        <div class="erp-info-item">
          <span>Estado</span>
          <strong class="erp-status-ok">Operativo</strong>
        </div>
      </section>
    </section>

    <!-- Panel derecho -->
    <section class="erp-actions-panel">
      <div class="erp-panel-title">
        <span class="erp-kicker">Accesos rápidos</span>
        <h2>Centro de operaciones</h2>
        <p>
          Accede a módulos, documentación, políticas y herramientas internas.
        </p>
      </div>

      <div class="erp-quick-actions">
        <a
          class="erp-action-card erp-action-card--clickable"
          href="/alimentacion/reservar"
          style="text-decoration: none; color: inherit"
          aria-label="Reservar alimentación"
        >
          <div class="erp-action-icon">
            <mat-icon>restaurant</mat-icon>
          </div>

          <div>
            <h3>Reservar alimentación</h3>
            <p>Elige restaurante, servicio y menú para tu reserva diaria.</p>
          </div>
        </a>

        <article
          class="erp-action-card erp-action-card--clickable"
          role="button"
          tabindex="0"
          (click)="copiarLinkActualizacionContacto()"
          (keydown.enter)="copiarLinkActualizacionContacto()"
        >
          <div class="erp-action-icon">
            <mat-icon>contact_mail</mat-icon>
          </div>

          <div>
            <h3>Actualizar contacto</h3>
            <p>Copiar link público para registrar correo personal y celular.</p>
          </div>
        </article>
        <article class="erp-action-card" *ngIf="show">
          <div class="erp-action-icon">
            <mat-icon>apps</mat-icon>
          </div>

          <div>
            <h3>Módulos</h3>
            <p>Acceso a todos los módulos del sistema.</p>
          </div>
        </article>

        <article class="erp-action-card" *ngIf="show">
          <div class="erp-action-icon">
            <mat-icon>menu_book</mat-icon>
          </div>

          <div>
            <h3>Documentación</h3>
            <p>Manuales, guías y procedimientos.</p>
          </div>
        </article>

        <article class="erp-action-card" *ngIf="show">
          <div class="erp-action-icon">
            <mat-icon>policy</mat-icon>
          </div>

          <div>
            <h3>Políticas</h3>
            <p>Normativas internas y cumplimiento.</p>
          </div>
        </article>

        <a
          class="erp-action-card erp-action-card--clickable"
          href="/mi-biometrico"
          style="text-decoration: none; color: inherit"
          aria-label="Registrar mi rostro"
        >
          <div class="erp-action-icon">
            <mat-icon>face</mat-icon>
          </div>

          <div>
            <h3>Registrar mi rostro</h3>
            <p>Configura tu registro para marcar asistencia. Es rápido y sencillo.</p>
          </div>
        </a>

        <a class="erp-action-card erp-action-card--clickable" href="/mis-asistencias" style="text-decoration: none; color: inherit" aria-label="Consultar mis asistencias">
          <div class="erp-action-icon"><mat-icon>calendar_month</mat-icon></div>
          <div><h3>Mis asistencias</h3><p>Consulta tu calendario, jornadas y marcaciones.</p></div>
        </a>

        <article
          class="erp-action-card erp-action-card--clickable"
          role="link"
          tabindex="0"
          (click)="abrirSoporteWhatsApp()"
          (keydown.enter)="abrirSoporteWhatsApp()"
        >
          <div class="erp-action-icon">
            <mat-icon>support_agent</mat-icon>
          </div>

          <div>
            <h3>Soporte</h3>
            <p>Reportar incidencias y solicitudes.</p>
          </div>
        </article>

        <article
          class="erp-action-card erp-action-card--clickable"
          role="button"
          tabindex="0"
          (click)="abrirFirma()"
        >
          <div class="erp-action-icon">
            <mat-icon>draw</mat-icon>
          </div>

          <div>
            <h3>Firma Corporativa</h3>
            <p>Generar y copiar firma institucional para correo Outlook.</p>
          </div>
        </article>

        <article
          class="erp-action-card erp-action-card--clickable"
          role="button"
          tabindex="0"
          (click)="irARegistrarUso()"
        >
          <div class="erp-action-icon">
            <mat-icon>health_and_safety</mat-icon>
          </div>

          <div>
            <h3>Registrar Uso de Maquinaria y Equipo</h3>
            <p>Registra el Uso de Maquinaria y Equipo de Trabajo.</p>
          </div>
        </article>

        <article
          class="erp-action-card erp-action-card--clickable"
          role="button"
          tabindex="0"
          (click)="irAFatiga()"
        >
          <div class="erp-action-icon">
            <mat-icon>health_and_safety</mat-icon>
          </div>

          <div>
            <h3>Medidor de Fatiga</h3>
            <p>Verificar el nivel de fatiga de los empleados.</p>
          </div>
        </article>
      </div>
    </section>
  </div>

  <footer class="erp-home-footer">
    <div class="footer-left">
      <strong>ZIVO ERP</strong>
      <span>v1.3.0</span>
      <span>© 2026 NOVAX EC</span>
    </div>

    <div class="footer-center">
      <span>
        Estado del sistema:
        <strong class="status-ok">Operativo</strong>
      </span>
    </div>

    <div class="footer-right">
      <a href="#" (click)="abrirPoliticaPrivacidad($event)">Política de privacidad</a>
      <span>Soporte: soporte&#64;novax.ec</span>
    </div>
    <div class="footer-brand">
      <img
        src="assets/img/NOVAXLOGO.png"
        alt="Novax"
        class="footer-novax-logo"
      />
    </div>
  </footer>
</main>

<!-- Modal Firma -->
<div class="erp-modal-backdrop" *ngIf="mostrarModalFirma">
  <section class="erp-modal erp-signature-modal">
    <header class="erp-modal-header erp-modal-header--split">
      <div>
        <h2>Generador de Firma Corporativa</h2>
        <p>
          Complete los datos institucionales, genere la firma y cópiela para
          usarla en Outlook.
        </p>
      </div>

      <button
        type="button"
        class="erp-icon-btn"
        title="Cerrar"
        aria-label="Cerrar"
        (click)="cerrarFirma()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="erp-signature-layout">
      <!-- Formulario -->
      <section class="erp-signature-form">
        <div class="erp-section-header">
          <div>
            <h3>Datos de la firma</h3>
          </div>
        </div>

        <div class="erp-form-grid">
          <label class="erp-field">
            <span>Nombre</span>
            <input
              [(ngModel)]="firma.nombre"
              placeholder="NOMBRE Y APELLIDO"
              [readonly]="!modoEdicionFirma"
            />
          </label>

          <label class="erp-field">
            <span>Cargo</span>
            <input
              [(ngModel)]="firma.cargo"
              placeholder="CARGO"
              [readonly]="!modoEdicionFirma"
            />
          </label>

          <label class="erp-field">
            <span>Teléfono</span>
            <input
              [(ngModel)]="firma.telefono"
              placeholder="0987654321"
              [readonly]="!modoEdicionFirma"
            />
          </label>

          <label class="erp-field">
            <span>Correo</span>
            <input
              [(ngModel)]="firma.correo"
              placeholder="correo@novax.ec"
              [readonly]="!modoEdicionFirma"
            />
          </label>
        </div>

        <div class="erp-unlock-box">
          <label class="erp-field">
            <span>Clave de edición</span>
            <input
              type="password"
              [(ngModel)]="claveFirma"
              placeholder="Ingrese la clave para editar"
            />
          </label>

          <button
            type="button"
            class="erp-btn erp-btn-light"
            (click)="validarClaveFirma()"
          >
            Desbloquear
          </button>
        </div>
      </section>

      <!-- Vista previa -->
      <section class="erp-signature-preview">
        <div class="erp-section-header erp-section-header--between">
          <div>
            <h3>Vista previa</h3>
          </div>

          <small class="erp-preview-hint">
            Se copiará como imagen para Outlook
          </small>
        </div>

        <div class="erp-preview-box">
          <div class="erp-preview-stage">
            <div
              id="firma-captura"
              class="firma-captura"
              [innerHTML]="firmaHtml"
            ></div>
          </div>
        </div>

        <div *ngIf="mensajeFirma" class="mensaje-firma">
          {{ mensajeFirma }}
        </div>
      </section>
    </div>

    <footer class="erp-modal-footer erp-modal-footer--between">
      <button
        type="button"
        class="erp-btn erp-btn-light"
        (click)="cerrarFirma()"
      >
        Cerrar
      </button>

      <div class="erp-footer-actions">
        <button
          type="button"
          class="erp-btn erp-btn-light"
          (click)="generarFirma()"
        >
          Generar
        </button>

        <button
          type="button"
          class="erp-btn erp-btn-primary"
          (click)="copiarFirma()"
          [disabled]="copiandoFirma"
        >
          <ng-container *ngIf="!copiandoFirma; else copiandoTpl">
            Copiar firma
          </ng-container>

          <ng-template #copiandoTpl>
            <span class="btn-spinner"></span>
            Copiando...
          </ng-template>
        </button>
      </div>
    </footer>
  </section>
</div>
<app-iframe-documentos-shared
  [show]="modalIframeDocumento"
  [url]="urlTemporalIframe"
  [title]="tituloIframeDocumento"
  [downloadName]="nombreDescargaIframeDocumento"
  [maximizar]="maximizarIframeDocumento"
  [allowDownload]="true"
  [closeOnEscape]="true"
  (close)="cerrarIframeDocumento()"
  (toggleMaximizar)="toggleMaximizarIframe()"
></app-iframe-documentos-shared>
